import React from 'react';

import {shouldDisableAuthorActions} from 'notebook/reviews/disableAuthorActions';
import postReviewActionServerUpdate from 'notebook/reviews/postReviewActionServerUpdate';
import ReviewBadge from 'notebook/reviews/ReviewBadge';
// @ts-expect-error
import EntryStore from 'stores/EntryStore';

interface EntryNoteTitleBadgeProps {
  enableReviewLifecycle: boolean;
  entryId: string;
  hasEnterprisePlan: boolean;
}

export function getReviewValidationError(reviewableId: string): string | null {
  if (EntryStore.inStore(reviewableId)) {
    const entryHasUnsavedChanges = EntryStore.hasUnsavedChanges(reviewableId) ?? false;
    // It is possible for entryStore.inStore(reviewableId) to pass before the entry itself is fully
    // loaded because the VersionedItemSubstore registers the reviewableId before the entry itself (see
    // EntryActions.open). We therefore need to check if the entry is loaded before accessing the note;
    // if not, we should disable sending for review.
    const note = EntryStore.getEntry(reviewableId)?.note;
    const {disableAuthorActionsTooltip} = shouldDisableAuthorActions(note);
    return entryHasUnsavedChanges ? 'Entry has unsaved changes' : disableAuthorActionsTooltip;
  }
  return 'Entry could not be found';
}

function EntryNoteTitleBadge({
  enableReviewLifecycle,
  entryId,
  hasEnterprisePlan,
}: EntryNoteTitleBadgeProps): JSX.Element | null {
  if (!hasEnterprisePlan) {
    return null;
  }
  return (
    <ReviewBadge
      className="noteEditor-reviewBadge"
      reviewableId={entryId}
      enableReviewLifecycle={enableReviewLifecycle}
      onReviewChange={postReviewActionServerUpdate}
      getSendForReviewValidationError={getReviewValidationError}
    />
  );
}

export default React.memo(EntryNoteTitleBadge);
